var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Viewer',{ref:"viewer",attrs:{"value":_vm.content || _vm.emptyText}})}
var staticRenderFns = []

export { render, staticRenderFns }